import { GFM_SITES } from "./permitSchemas";

// Sites a user is allowed to act on. Admins get every site; site users get
// only the sites assigned to them (in canonical order).
export function allowedSites(user) {
  if (!user || user.role === "admin") return GFM_SITES;
  const assigned = user.sites || [];
  return GFM_SITES.filter((s) => assigned.includes(s));
}

export function isAdmin(user) {
  return user?.role === "admin";
}
